import { useTranslation } from 'react-i18next'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Check } from 'lucide-react'
import type { RequestApproval } from '../api'

interface RequestApprovalApproveDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    requestApproval: RequestApproval | null
    onConfirm: () => void
    isLoading?: boolean
}

export function RequestApprovalApproveDialog({
    open,
    onOpenChange,
    requestApproval,
    onConfirm,
    isLoading = false,
}: RequestApprovalApproveDialogProps) {
    const { t } = useTranslation()
    if (!requestApproval) return null

    const objectID = requestApproval.objectID || ''
    const objectDescription = requestApproval.objectDescription || ''

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <Check className="h-5 w-5 text-green-600" />
                        {t('requestApprovals.approveTitle')}
                    </DialogTitle>
                    <DialogDescription>
                        {t('requestApprovals.confirmApprove', { 
                            objectID, 
                            objectDescription 
                        })}
                    </DialogDescription>
                </DialogHeader>

                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                        disabled={isLoading}
                    >
                        {t('common.cancel')}
                    </Button>
                    <Button
                        variant="default"
                        className="bg-green-600 hover:bg-green-700"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? t('requestApprovals.approving') : t('requestApprovals.approve')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
